import { render, staticRenderFns } from "./Wrap.vue?vue&type=template&id=580d0e2e&"
import script from "./Wrap.vue?vue&type=script&lang=js&"
export * from "./Wrap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports